import { render, staticRenderFns } from "./dispjilu.vue?vue&type=template&id=5f5fa5ba&"
import script from "./dispjilu.vue?vue&type=script&lang=js&"
export * from "./dispjilu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports